import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaLoading } from '@inter-ikea-guida/skapa';
const StyledLoadingContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width || '100vw'};
  height: ${props => props.height || '100vh'};
`;
const LoadingIndicator = ({ width, height }) => (_jsx(StyledLoadingContainer, { width: width, height: height, children: _jsx(SkapaLoading, {}) }));
export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map